import classNames from 'classnames';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { MenuItemType } from '../../constants/menuItems';
import * as ExpressionSVGs from '../svgs/ExpressonSVGs';
import Link from './Link';

type SecondMenuProps = {
	wrapperClasses?: string;
	menuItems: MenuItemType[];
}

const SecondMenu: React.FC<SecondMenuProps> = ({ 
	wrapperClasses = '',
	menuItems = [],
}) => {
	const location = useLocation();

	/**
	 * Get the icon component by name from ExpressionSVGs
	 */
	const getIconComponent = (iconName: string) => {
		const IconComponent = ExpressionSVGs[iconName as keyof typeof ExpressionSVGs];
		return IconComponent || null;
	};

	/**
	 * Check if the menu item is active based on current pathname
	 */
	const isActive = (urlPath: string) => {
		return location.pathname === urlPath || location.pathname.startsWith(`${urlPath}/`);
	};

	return (
		<div
			className={classNames(
				'Section second-menu',
				wrapperClasses
			)}
		>
			<div className="Row">
				<div className={classNames(
					'Row__Inner',
					'white-pale-section',
					'shadow-one',
					'second-menu-inner'
				)}>
					<nav className="second-menu-wrapper">
						<ul className={classNames(
							'second-menu-list',
							{ 'three-items': menuItems.length === 3 }
							)}
						>
							{menuItems.map(([menuName, menuIconName, urlPath], index) => {
								const IconComponent = getIconComponent(menuIconName);
								const active = isActive(urlPath);

								return (
									<li
										key={`${urlPath}-${index}`}
										className={classNames('second-menu-item', {
											'second-menu-item--active': active
										})}
									>
										<Link href={urlPath} className="second-menu-link">
											{IconComponent && (
												<span className="second-menu-icon">
													<IconComponent />
												</span>
											)}
											<span className="second-menu-label">
												{menuName}
											</span>
										</Link>
									</li>
								);
							})}
						</ul>
					</nav>
				</div>
			</div>
		</div>
	)
}

export default SecondMenu;
